import { useToggleFavorite } from '@libs/common-next';

import { useAutoAddToFavorites } from './useAutoAddToFavorites';
import { usePendingFavoriteAfterAuth } from './usePendingFavoriteAfterAuth';

type UseFavoriteToggleWithAutoAddProps = {
    onAddActionCallback: () => void;
    onErrorCallback: (props: { error: Error; event: 'add' | 'remove' }) => void;
    sku: string | undefined;
    userId: string | undefined;
    isFavorite: boolean | undefined;
    isFavoritesLoading: boolean;
};

export const useFavoriteToggleWithAutoAdd = ({
    onAddActionCallback,
    onErrorCallback,
    sku,
    userId,
    isFavorite,
    isFavoritesLoading,
}: UseFavoriteToggleWithAutoAddProps) => {
    const mutation = useToggleFavorite({
        onAddActionCallback,
        onErrorCallback,
    });

    const mutate = (params: { sku: string; action: 'add' | 'remove' }) => {
        if (!userId) return;
        mutation.mutate({
            ...params,
            userId,
        });
    };

    const { triggerAddAfterLogin } = useAutoAddToFavorites({
        sku,
        userId,
        isFavorite,
        isFavoritesLoading,
        isTogglePending: mutation.isPending,
        toggleFavorite: mutate,
    });

    usePendingFavoriteAfterAuth({
        sku,
        userId,
        isFavorite,
        isFavoritesLoading,
        isTogglePending: mutation.isPending,
        toggleFavorite: mutate,
    });

    return {
        mutate,
        isPending: mutation.isPending,
        triggerAddAfterLogin,
    };
};
